// Timbo collaborative bridge (v4.04.x) — Supabase magic-link auth.
// Env-driven: if REACT_APP_SUPABASE_URL / _ANON_KEY are absent, `supabase`
// is null and the app runs OPEN (dev/preview keeps working, no gate).
//
// Owner vs guest is derived from email allowlists (comma-separated envs):
//   REACT_APP_OWNER_EMAILS   — see Performance, admin surfaces (default: Yann)
//   REACT_APP_ALLOWED_EMAILS — who may sign in at all (empty = any logged-in email)

import { createClient } from '@supabase/supabase-js';

const url  = process.env.REACT_APP_SUPABASE_URL;
const anon = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = (url && anon)
  ? createClient(url, anon, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    })
  : null;

const parseList = (s) => (s || '')
  .split(',').map(x => x.trim().toLowerCase()).filter(Boolean);

export const OWNER_EMAILS   = parseList(process.env.REACT_APP_OWNER_EMAILS || 'yann@photoroom.com');
export const ALLOWED_EMAILS = parseList(process.env.REACT_APP_ALLOWED_EMAILS);

export function isOwner(email) {
  return !!email && OWNER_EMAILS.includes(String(email).toLowerCase());
}

export function isAllowed(email) {
  if (!email) return false;
  const e = String(email).toLowerCase();
  if (OWNER_EMAILS.includes(e)) return true;
  if (ALLOWED_EMAILS.length === 0) return true; // no allowlist configured → any logged-in email
  return ALLOWED_EMAILS.includes(e);
}

export async function signOut() {
  try { if (supabase) await supabase.auth.signOut(); } catch {}
  try {
    localStorage.removeItem('timbo_user_email');
    localStorage.removeItem('timbo_user_role');
  } catch {}
}

export function currentUser() {
  try {
    return {
      email: localStorage.getItem('timbo_user_email') || '',
      role:  localStorage.getItem('timbo_user_role')  || 'owner',
    };
  } catch { return { email: '', role: 'owner' }; }
}

// Current access token (JWT) for authorizing sensitive backend calls.
export async function getAccessToken() {
  if (!supabase) return null;
  try {
    const { data } = await supabase.auth.getSession();
    return data?.session?.access_token || null;
  } catch { return null; }
}
